// TES-1074 point 4 — the link targets "Patienten i korthet" opens: a row in
// Patientminnet, and F-01's original answers. Shared so the link and the
// target cannot drift apart.

export const F01_ORIGINALS_ANCHOR = "f01-originalsvar";

export function memoryItemAnchor(itemId: string): string {
  return `minne-${itemId}`;
}

/** The memory row a location hash points at, or null. */
export function memoryItemIdOfHash(hash: string): string | null {
  const prefix = `#${memoryItemAnchor("")}`;
  return hash.startsWith(prefix) && hash.length > prefix.length
    ? decodeURIComponent(hash.slice(prefix.length))
    : null;
}

// TES-1211 — Patientminnet itself, for "… fler noteringar i Patientminnet".
export const PATIENT_MEMORY_ANCHOR = "patientminne";
